import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse, PaginatedApiResponse } from '@card-software/library';
import { environment } from '../../environments/environment';

export interface RollSummary {
  id?: string;
  number?: string;
}

@Injectable({ providedIn: 'root' })
export class RollProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.productionApi + '/api/v1/roll';

  public search(query: string, pageSize = 50): Observable<ApiResponse<PaginatedApiResponse<RollSummary>>> {
    const params = new HttpParams().set('pageNumber', 1).set('pageSize', pageSize);
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<RollSummary>>>(
      `${this.baseUrl}/search/paginated`,
      { rollNumbers: query ? [query] : null },
      { params },
    );
  }
}
